import { StateCreator } from "zustand";
import { RemoteFetchUserRoles } from "../../data/usecases/remote-fetch-user-roles";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../base";
import { TerritoryData } from "../../domain/models/territory-data";
import Endpoints from "../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchUserRolesInterface {
  userRolesMasterData: TerritoryData[];
  fetchUserRolesMaster: Function;
}

const initialStates = {
  userRolesMasterData: [],
};
const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchUserRolesSlice: StateCreator<FetchUserRolesInterface> = (
  set, get
) => ({
  ...initialStates,
  fetchUserRolesMaster: async () => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchUserRoles = new RemoteFetchUserRoles(
      `${BASE_URL}${Endpoints.FETCH_ROLES}`,
      axiosHttpClient
    );
    let result = await remoteFetchUserRoles.fetch();
    if (result.success) {
      set(() => ({ userRolesMasterData: result.roles }));
    }
  },
});
